export default "__VITE_ASSET__CV7Ir6DX__"